module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"empty":"По заданным условиям вакансий не найдено"}}')
  delete Component.options._Ctor
}
